import * as Yup from 'yup'

export const API_KEY = 'api_key'
export const AD_SERVER_TYPE = 'ad_server_type'

export const adServers = {
  adbutler: 'adbutler'
}

export const adServersList = [
  {
    value: adServers.adbutler,
    label: 'Ad Butler'
  }
]

export const validationSchema = Yup.object({
  [AD_SERVER_TYPE]: Yup.string().required('This field is required'),
  [API_KEY]: Yup.string().required('This field is required')
})
